import { Device, Media } from '@/generated/graphql';

export type DeviceState = {
  created?: boolean;
  installed?: boolean;
  installationFailed?: boolean;
  productionReady?: boolean;
  disabled?: boolean;
};

export type DeviceConfig = {
  state: DeviceState;
};

export interface ClientDevice extends Device {
  lastProcessedMedia: Media[];
}

export enum MediaKind {
  ORIGINAL = 'Original',
  MASKED = 'Masked',
  PROCESSED = 'Processed',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type JSONConfig = any;

export const PRODUCTS = ['senforce', 'senpic', 'senshield'] as const;

export type Product = (typeof PRODUCTS)[number];
